<template>
  <div data-component="app-launcher-header">
    <or-tooltip :content="$t('HITL.modules.app-header.go-to-action-desk')">
      <div
        class="back-button"
        @click="$emit('go-back')"
      >
        <or-icon icon="arrow_back" />
      </div>
    </or-tooltip>

    <div class="center-title">
      {{ $t('HITL.app-launcher.title') }}
    </div>

    <div
      v-if="!!agent"
      class="buttons-block"
    >
      <app-launcher-header-agent-popup
        :avatar="avatar"
        :agent="agent"
        :app-version="appVersion"
        @option-click="onOptionClick"
        @sign-out="$emit('sign-out')"
      />
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue-demi';
import { OrIconV3 as OrIcon, OrTooltipV3 as OrTooltip } from '@onereach/ui-components-25';

import AppLauncherHeaderAgentPopup from './AppLauncherHeaderAgentPopup.vue';
import { AVATAR_PROP, AGENT_PROP, ACTIONS_TYPE_PROP } from '../constants';

export default defineComponent({
  name: 'AppLauncherHeader',
  components: {
    OrIcon,
    OrTooltip,
    AppLauncherHeaderAgentPopup,
  },
  props: {
    avatar: AVATAR_PROP,
    agent: AGENT_PROP,
    actionsType: ACTIONS_TYPE_PROP,
    appVersion: {
      type: String,
      default: '',
    },
  },
  emits: ['go-back', 'option-click', 'sign-out'],
  methods: {
    onOptionClick(key: string) {
      this.$emit('option-click', key);
    },
  },
});
</script>

<style lang="scss" scoped>
@use '@/styles' as *;

[data-component='app-launcher-header'] {
  display: flex;
  align-items: center;
  gap: var(--s-4);
  height: 4.3125rem;
  padding: var(--s-4) var(--s-5);
  background: var(--or-c-background);
  border-bottom: 1px solid var(--or-c-outline-variant);

  .back-button,
  .buttons-block {
    display: flex;
    align-items: center;
  }

  .back-button {
    color: var(--or-c-on-background);
    cursor: pointer;
    flex: 0 0 auto;

    .or-icon-v3 {
      height: 1.25rem;
      width: 1.25rem;
      font-size: 1.25rem;
    }
  }

  .center-title {
    flex: 1;
    text-align: center;
    font-size: 1.25rem;
    font-weight: var(--fw-2);
    color: var(--or-c-on-background);
    line-height: 1.5;
  }

  .buttons-block {
    flex: 0 0 auto;
    margin-left: auto;
  }
}
</style>
